if ( typeof ProductBundler !== 'function' ) {

  class ProductBundler extends HTMLElement {

    constructor() {

      super();

      if ( this.querySelector('css-slider') ) {
        this.querySelector('css-slider').addEventListener('ready', ()=>{
          this.init();
        })
      } else {
        this.init();
      }

    }

    initBundler() {

      this._bundleMin = parseInt(this.dataset.minimum);
      this._bundleTemplate = this.querySelector('[data-js-bundler-product]').cloneNode(true);

      this.querySelectorAll('[data-js-bundler-product-remove]').forEach(elm=>{
        elm.addEventListener('click', e=>{
          this.clearSlot(e.target.closest('[data-js-bundler-product]'));
        });
      });

      this.querySelector('[data-js-bundler-toggle]').addEventListener('click', e=>{
        if ( window.innerWidth < 768 ) {
          this.classList.toggle('opened');
        }
      });

      this.querySelector('[data-js-add-bundle-to-cart]').addEventListener('click', e=>{

        let items = [];
        this.bundleProducts.map(elm=>{
          if ( elm.dataset.id ) {
            if ( ! items.find(item => {
              if ( item.id == elm.dataset.id ) {
                item.quantity++;
                return true;
              }
            }) ) {
              items.push({
                id: elm.dataset.id,
                quantity: 1
              })
            }
          }
        })

        if ( items.length > 0 ) {

          const submitButton = this.querySelector('[data-js-add-bundle-to-cart]');
          submitButton.classList.add('working');
          window.handleAddToCart(
            JSON.stringify({'items': items}), items.reduce((total, { quantity }) => total + quantity, 0),
            { 'Content-Type': 'application/json' },
            ()=>{
              submitButton.classList.remove('working');
              this.querySelectorAll('[data-js-bundler-product]').forEach(elm=>{
                if ( !elm.classList.contains('bundler-product--empty') ) {
                  this.clearSlot(elm);
                }
              });
              this.classList.remove('opened');
            }
          );

        }

      });

    }

    initProducts() {

      this.bundleProducts = [...this.querySelectorAll('[data-js-bundler-product]')];

      this.querySelectorAll('[data-js-product-add-to-cart]').forEach(elm=>{
        if ( ! elm.hasAttribute('data-init') ) {

          elm.addEventListener('click', e=>{
            e.preventDefault();
            const product = e.target.closest('[data-js-product-item]');
            product.querySelector('.button__text').innerHTML = KROWN.settings.locales.products_added_to_bundle_label;
            const variant = product.querySelector('product-variants').currentVariant;
            this.addToBundle(variant, product);
            this.classList.add('opened');
          });
          elm.setAttribute('data-init', '');

          elm.closest('.product-item').addEventListener('reload', e=>{
            this.initProducts();
          });

        }
      });

    }

    init() {
      this.initBundler();
      this.initProducts();
      this.updateBundleStatus();
    }

    findEmptySlot() {
      return this.bundleProducts.find(elm=>{
        return elm.classList.contains('bundler-product--empty')
      });
    }

    countFilledSlots() {
      return this.bundleProducts.filter(elm=>{
        return !elm.classList.contains('bundler-product--empty') && elm.dataset.id;
      }).length;
    }

    updateBundleStatus() {
      const statusElm = this.querySelector('.bundler__header-subtitle');
      const submitBtn = this.querySelector('[data-js-add-bundle-to-cart]');
      const filled = this.countFilledSlots();
      const min = this._bundleMin;
      const remaining = min - filled;

      if ( statusElm ) {
        if ( filled === 0 ) {
          statusElm.textContent = 'Pick your first piece';
        } else if ( filled === 1 ) {
          statusElm.textContent = 'Make it a set with 1 more';
        } else if ( filled === 2 ) {
          statusElm.textContent = "That's a set. 1 more for a bundle and 15% off.";
        } else {
          statusElm.textContent = "That's a bundle. 15% off at checkout.";
        }
      }

      if ( submitBtn ) {
        if ( filled === 0 ) {
          submitBtn.setAttribute('disabled', '');
        } else {
          submitBtn.removeAttribute('disabled');
        }
      }
    }

    getVendorFromCard(product) {
      const vendorElm = product.querySelector('.product-item__vendor');
      if ( !vendorElm ) return '';
      return vendorElm.textContent.trim();
    }

    clearSlot(slot) {
      if ( slot.classList.contains('bundler-product--empty') ) {
        return;
      }
      if ( slot.product ) {
        slot.product.querySelector('[data-js-product-add-to-cart-text]').textContent = KROWN.settings.locales.products_add_to_bundle_button;
      }
      if ( this.bundleProducts.length > this._bundleMin ) {
        this.bundleProducts.splice(this.bundleProducts.indexOf(slot), 1);
        if ( slot.product ) {
          slot.product.classList.remove('product-item--bundled');
        }
        slot.remove();
      } else {
        if ( slot.product ) {
          slot.product.classList.remove('product-item--bundled');
        }
        slot.dataset.id = "";
        slot.dataset.variant = null;
        slot.product = null;
        slot.classList.add('bundler-product--empty');
        slot.querySelector('[data-js-bundler-product-text]').innerHTML = '';
        slot.querySelector('[data-js-bundler-product-image]').innerHTML = '';
      }
      if ( this.findEmptySlot() ) {
        this.classList.remove('bundler-full');
      }
      this.reorderSlots();
      this.updateBundleStatus();
    }

    reorderSlots() {
      let ei = 0,
          fi = -100;
      this.querySelectorAll('[data-js-bundler-product]').forEach((elm, i)=>{
        if ( elm.classList.contains('bundler-product--empty') ) {
          elm.style.order = ei++;
        } else {
          elm.style.order = fi++;
        }
      });
    }

    createSlot(){
      const newSlot = this._bundleTemplate.cloneNode(true);
      newSlot.querySelector('[data-js-bundler-product-remove]').addEventListener('click', e=>{
        this.clearSlot(e.target.closest('[data-js-bundler-product]'));
      });
      this.querySelector('[data-js-bundler-products]').appendChild(newSlot);
      this.bundleProducts.push(newSlot);
    }

    addToBundle(variant, product) {

      let slot = this.findEmptySlot();
      const imageSrc = variant.featured_image ? variant.featured_image.src : product.querySelector('[data-js-quick-buy-product-image]').textContent;
      const vendor = this.getVendorFromCard(product);

      if ( ! slot && this.hasAttribute('data-limit-maximum') ) {
        this.createSlot();
        slot = this.findEmptySlot();
      }

      if ( slot ) {

        slot.classList.remove('bundler-product--empty');
        slot.querySelector('[data-js-bundler-product-text]').innerHTML = `
          ${ vendor ? `<span class="bundler-product__text-vendor text-color--opacity text-size--small">${vendor}</span>` : '' }
          <span class="bundler-product__text-title text-line-height--medium text-weight--bold">${product.querySelector('[data-js-quick-buy-product-title]').textContent}</span>
          ${ product.querySelector('product-variants').hasAttribute('data-has-variants') ? `<span class="bundler-product__text-variant text-color--opacity">${variant.title}</span>` : '' }
        `;
        slot.querySelector('[data-js-bundler-product-image]').innerHTML = `
          <img src="${this.getResizedImageSrc(imageSrc, 60)}"
            srcset="
              ${this.getResizedImageSrc(imageSrc, 60)} 60w,
              ${this.getResizedImageSrc(imageSrc, 120)} 120w,
              ${this.getResizedImageSrc(imageSrc, 180)} 180w
            "
            sizes="60px"
          />
        `;

        if ( this.hasAttribute('data-limit-bundles') ) {
          product.classList.add('product-item--bundled');
        }
        slot.product = product;
        slot.dataset.id = product.querySelector('input[name="id"]').value;
        slot.dataset.variant = product.querySelector('product-variants').currentVariant;

      } else {
        // when bundle is full, show message
      }

      if ( ! this.findEmptySlot() ) {
        this.classList.add('bundler-full');
      }

      this.updateBundleStatus();

    }

    getResizedImageSrc(src, size, crop='center') {
      return (`${src}${src.includes('?') ? '&' : '?'}width=${size}&height=${size}&crop=${crop}`).replace(/\n|\r|\s/g, "");
    }

  }

  if ( typeof customElements.get('product-bundler') == 'undefined' ) {
    customElements.define('product-bundler', ProductBundler);
  }

}

(function bundleSwatchAvailability() {

  const productCache = new Map();

  async function loadProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    try {
      const response = await fetch('/products/' + handle + '.js');
      if (!response.ok) return null;
      const data = await response.json();
      productCache.set(handle, data);
      return data;
    } catch (e) {
      return null;
    }
  }

  function getProductHandle(productItem) {
    const link = productItem.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function getColorSwatches(productItem) {
    return productItem.querySelectorAll('.product-variant__item--color');
  }

  function getSelectedSize(productItem) {
    const variants = productItem.querySelectorAll('.product-variant');
    for (const v of variants) {
      if (v.querySelector('.product-variant__item--color')) continue;
      const checked = v.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;
    }
    return null;
  }

  function clearSwatchDisabled(swatch) {
    swatch.classList.remove('disabled');
    const input = swatch.querySelector('input');
    if (input) {
      input.classList.remove('disabled');
      if (!input.hasAttribute('data-disabled')) {
        input.removeAttribute('disabled');
      }
    }
  }

  function applySwatchDisabled(swatch) {
    swatch.classList.add('disabled');
    const input = swatch.querySelector('input');
    if (input) input.classList.add('disabled');
  }

  function updateSwatches(productItem, productJson) {
    const selectedSize = getSelectedSize(productItem);
    const swatches = getColorSwatches(productItem);

    swatches.forEach(swatch => {
      const input = swatch.querySelector('input');
      const color = input ? input.value : null;
      if (!color) return;

      if (!selectedSize) {
        clearSwatchDisabled(swatch);
        return;
      }

      const variant = productJson.variants.find(v => {
        return v.options.indexOf(selectedSize) !== -1 && v.options.indexOf(color) !== -1;
      });

      if (variant && variant.available) {
        clearSwatchDisabled(swatch);
      } else {
        applySwatchDisabled(swatch);
      }
    });
  }

  async function initProductCard(productItem) {
    if (productItem.dataset.bundleSwatchInit) return;
    productItem.dataset.bundleSwatchInit = '1';

    const handle = getProductHandle(productItem);
    if (!handle) return;

    const productJson = await loadProduct(handle);
    if (!productJson) return;

    updateSwatches(productItem, productJson);

    productItem.addEventListener('change', () => {
      updateSwatches(productItem, productJson);
    });
  }

  function initAll() {
    document.querySelectorAll('product-bundler [data-js-product-item]').forEach(initProductCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(initAll, 800));
  } else {
    setTimeout(initAll, 800);
  }

  setTimeout(initAll, 2000);
  setTimeout(initAll, 4000);

})();
